<sh-notifications style="z-index: 20000;" position="top-right">
  <sh-notification-item [visible]="isNotificationVisible"
    duration="long"
    id="show-notification"
    [label]="notification?.label"
    [type]="notification?.type"
  >
    {{ notification?.description }}
  </sh-notification-item>
</sh-notifications>
